<script>
export default {
    props: {
        modelValue: {
            type: Boolean
        },
        modalClasses: {
            type: String,
            default: ''
        },
        modalContainerClasses: {
            type: String,
            default: ''
        },
        closeClickAway: {
            type: Boolean,
            default: false
        },
        onClose: {
            type: Function,
            default: () => {
            }
        },
        cleanUp: {
            type: Function,
            default: () => {
            }
        },
        modalId: {
            type: String,
            default: 'simpleModal'
        }
    },
    emits: ['update:modelValue'],
    mounted() {
        this.$refs.modal.focus()
        document.querySelector('body').classList.add('overflow-hidden')
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
    },
    beforeUnmount() {
        document.querySelector('body').classList.remove('overflow-hidden')
        window.removeEventListener('resize', this.handleResize)
        this.cleanUp()
    },
    methods: {
        handleResize() {
            const bottom = this.$refs.modal.getBoundingClientRect().bottom + 128

            if (bottom >= window.innerHeight) {
                this.$refs.modal.classList.add('overflow-scroll')
            } else {
                this.$refs.modal.classList.remove('overflow-scroll')
            }
        },
        close() {
            this.onClose()
            this.$emit('update:modelValue', false)
        },
        clickAway() {
            if (!this.closeClickAway) return
            this.close()
        }
    }
}
</script>

<template>
    <teleport to="body">
        <transition
            mode="out-in"
            name="fade"
        >
            <section
                class="flex fixed top-0 left-0 z-40 flex-col items-center p-16 w-screen h-screen bg-gray-700 bg-opacity-50"
                :class="modalContainerClasses"
                @click.self="clickAway"
            >
                <div
                    :id="modalId"
                    ref="modal"
                    class="bg-white rounded focus:outline-none"
                    :class="modalClasses"
                    tabindex="0"
                    @keydown.esc="close"
                >
                    <slot
                        :close="close"
                        :resize="handleResize"
                    />
                </div>
            </section>
        </transition>
    </teleport>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.15s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
